import { Delete, PersonAdd, Print } from "@mui/icons-material";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import ReusableFormFields from "../../../common/textfield/ReusableTextfield";

const AttenderFormDrawer = ({
  open,
  onClose,
  selectedPatient,
  attendersList,
  handleAddAttender,
  handleRemoveAttender,
  onSubmit,
  submitting,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      attender_name_0: "",
      relation_0: "",
      phone_0: "",
      address_0: "",
    },
  });

  const generateAttenderFormFields = (index) => {
    return [
      {
        name: `attender_name_${index}`,
        label: "Attender Name",
        rules: { required: "Attender name is required" },
      },
      {
        name: `relation_${index}`,
        label: "Relation",
        type: "select",
        options: [
          { value: "1", label: "Spouse" },
          { value: "2", label: "parent" },
          { value: "3", label: "child" },
          { value: "4", label: "sibling" },
          { value: "5", label: "friend" },
          { value: "6", label: "Other" },
        ],
        rules: { required: "Relation is required" },
      },
      {
        name: `phone_${index}`,
        label: "Phone Number",
        type: "text",
        maxLength: 10, 
        showCharCount: false, 
        rules: {
          required: "Phone number is required",
          pattern: {
            value: /^(6|7|8|9)\d{9}$/,
            message: "Please enter a valid 10-digit phone number",
          },
        },
      },
      {
        name: `address_${index}`,
        label: "Address",
        multipleLine: true,
        rules: { required: "Address is required" },
      },
    ];
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: "500px" },
      }}
    >
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Add Attenders for {selectedPatient?.patientName || "Patient"}
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Admission No: {selectedPatient?.admissionNo}
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          {attendersList.map((attender, index) => (
            <Paper key={attender.id} elevation={1} sx={{ p: 2, mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 1,
                }}
              >
                <Typography variant="subtitle1">
                  Attender {index + 1}
                </Typography>
                {attendersList.length > 1 && (
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleRemoveAttender(attender.id)}
                  >
                    <Delete />
                  </IconButton>
                )}
              </Box>
              <ReusableFormFields
                inputFields={generateAttenderFormFields(index)}
                control={control}
                errors={errors}
                required={true}
                defaultSize="small"
                gridProps={{ xs: 12 }}
              />
            </Paper>
          ))}

          <Box sx={{ mt: 2, mb: 2 }}>
            <Button
              variant="outlined"
              color="info"
              startIcon={<PersonAdd />}
              onClick={handleAddAttender}
            >
              Add Another Attender
            </Button>
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="success"
              disabled={submitting}
              startIcon={<Print />}
            >
              Submit & Print
            </Button>
          </Box>
        </form>
      </Box>
    </Drawer>
  );
};

export default AttenderFormDrawer;